import { inject, Injectable } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap, } from "rxjs/operators";
import * as bookAction from "./book.actions";
import { EmptyAction } from "..";
import { SnackBarService } from "../../services/snackbar.service";
import { UserBookService } from "../../services/user-book.service";


@Injectable()
export class BookEffect {
    // Inject Services and Actions
    private actions$ = inject(Actions);
    private bookService = inject(UserBookService);
    private snackBarService = inject(SnackBarService);


    // Fetch Book Info
    fetchBookInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType(bookAction.FetchBookInfoAction),
            switchMap((props) => {
                return this.bookService.getBookInfo(props.bookId).pipe(
                    map((res) => {
                        return bookAction.FetchBookInfoSuccessAction({
                            response: {
                                Value: res
                            }
                        });
                    }),
                    catchError(err => {
                        return of(bookAction.FetchBookInfoFailureAction({
                            error: err.error
                        }))
                    })
                );
            })
        )
    );

    // Fetch Book Info Success
    fetchBookInfoSuccess$ = createEffect(() =>
        this.actions$.pipe(
            ofType(bookAction.FetchBookInfoSuccessAction),
            switchMap((props) => {
                return of(EmptyAction());
            })
        )
    );

    // Fetch Book Info Failure
    fetchBookInfoFailure$ = createEffect(() =>
        this.actions$.pipe(
            ofType(bookAction.FetchBookInfoFailureAction),
            switchMap((props) => {
                console.error('Fetching Book Failed');
                return of(EmptyAction());
            })
        )
    );
}
